module.exports = __webpack_public_path__ + "img/covert.dbc41ed5.svg";